import { Injectable } from '@angular/core';
import { LockingIndexedService } from './locking-indexed.service';
import { logger, Query, QueryService, SearchResult } from '@damofire/data-commons';

@Injectable()
export class IndexedQueryService extends QueryService {
  constructor(private readonly idbService: LockingIndexedService) {
    super();
  }

  async collection<T>(store: string, division: string, query: Query, searchFields?: string[]): Promise<SearchResult<T>> {
    logger.debug('Starting search in store.', { store, division, category: 'idb' });
    const start = new Date().getTime();
    const collection = await this.idbService.getAllFromIndex<T>(division, store, 'division', division);
    const endIndex = new Date().getTime();
    logger.debug('Done fetching data in indexeddb.', { store, durationMs: endIndex - start, category: 'idb' });

    const searchResult = this.search<T>(collection, query, searchFields);
    const endFiltering = new Date().getTime();
    logger.debug('Done filtering / paginating search result.', { store, durationMs: endFiltering - endIndex, category: 'idb' });
    return searchResult;
  }
}
